import React, { useEffect, useRef, useState } from "react";
import TelephoneNumbers from "../../TelephoneNumbers";
import { useTranslation } from "react-i18next";
import { MDBInput, MDBSelect } from "mdb-react-ui-kit";
import { useNavigate } from "react-router";
import {
  getMisc,
  updateLunaDetails,
  updateLunaSettings,
} from "../../../apiclients/streamsapi_bridge";
import Voice1 from "../../../uimedia/lunavoices/Alloy_aka_Luna_tts-1-hd.mp3";
import Voice2 from "../../../uimedia/lunavoices/Echo_aka_Eric_tts-1-hd.mp3";
import Voice3 from "../../../uimedia/lunavoices/Ash_aka_Oscar_tts-1-hd.mp3";
import Voice4 from "../../../uimedia/lunavoices/Shimmer_aka_Serena_tts-1-hd.mp3";

function LunaGeneralSettings({
  register,
  setValue,
  getValues,
  watch,
  errors,
  clearErrors,
  setError,
  phoneNumbers,
  lunaid,
  setSuccessMessage,
  allLocations,
  billingGroupList,
  setIsloading,
  assocCallFlows
}) {
  const { t, i18n } = useTranslation();
  const [checkAvailbility, setCheckAvailbility] = useState(false);
  const navigate = useNavigate();
  let apiRequest = false;
  const [defaultExtension, setDefaultExtension] = useState(0);

  const [sourceNumber, setSourceNumber] = useState([]);
  const [selectedPHnums, setSelectedPHnums] = useState([]);
  const [deleteNumberFlag, setDeleteNumberFlag] = useState(false);
  const [freePhoneFlag, setfreePhoneFlag] = useState(true);
  const [updatePHNum, setUpdatePHNum] = useState([]);
  const [updateNumbersExecuted, setUpdateNumbersExecuted] = useState(false);
  const [dbPhoneNumbers, setdbPhoneNumbers] = useState([]);

  const voices = [
    { voiceid: 1, voiceurl: Voice1, title: "Luna" },
    { voiceid: 2, voiceurl: Voice2, title: "Eric" },
    { voiceid: 3, voiceurl: Voice3, title: "Oscar" },
    { voiceid: 4, voiceurl: Voice4, title: "Serena" },
  ];

  const [selectedVoice, setSelectedVoice] = useState(Voice1);
  const audioRef = useRef(null);

  useEffect(() => {
    if (phoneNumbers?.length > 0) {
      setSelectedPHnums(phoneNumbers);
      setdbPhoneNumbers(phoneNumbers);
    }
  }, [phoneNumbers]);
  useEffect(() => {
    if (freePhoneFlag) {
      getFreePhoneNumbers();
      setfreePhoneFlag(false);
    }
  }, [freePhoneFlag]);

  async function getFreePhoneNumbers() {
    let updates = {};
    console.log(sessionStorage.getItem("admin_session"));
    updates = {
      misc: ["free_dids"],
    };

    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      updates
    );
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const basicInfo = await response.json();
    if (!basicInfo) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    console.log("response data is :::::::::: " + JSON.stringify(basicInfo));
    setSourceNumber(basicInfo.misc.free_dids);
  }

  async function checkAvailability(e) {
    e.preventDefault();
    e.stopPropagation();
    apiRequest = true;
    console.log(sessionStorage.getItem("admin_session"));
    const response = await getMisc(
      JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      { check_ext: parseInt(e.target.value) }
    );
    console.log(response);
    if (!response.json) {
      const message = `An error has occured: ${response.statusText}`;
      return;
    }
    const tdata = await response.json();
    if (!tdata) {
      window.alert(`info with id  not found`);
      navigate("/");
    }
    if (apiRequest) {
      if (tdata.check_ext) {
        setCheckAvailbility(true);
        setError("general.extension", { message: "Extension is available" });
      } else {
        setCheckAvailbility(false);
        setError("general.extension", {
          message: "Extension is not available",
        });
      }
      apiRequest = false;
    } else {
      clearErrors("general.extension");
      setCheckAvailbility(false);
    }
    console.log(tdata);
  }

  useEffect(() => {
    if (updatePHNum.length > 0 && updateNumbersExecuted) {
      addPhoneNumbers("added_dids");
      setUpdateNumbersExecuted(false);
    }
  }, [updatePHNum, updateNumbersExecuted]);

  useEffect(() => {
    if (updatePHNum.length > 0 && deleteNumberFlag) {
      addPhoneNumbers("removed_dids");
      setDeleteNumberFlag(false);
    }
  }, [updatePHNum, deleteNumberFlag]);

  async function addPhoneNumbers(fieldName) {
    setIsloading(true);
    let update = {
      reqid: 149,
      siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
      lunaid: lunaid,
      [fieldName]: updatePHNum,
    };

    console.log(JSON.stringify(update));
    //alert(JSON.stringify(update));
    let saverep = await updateLunaSettings(update);
    console.log(saverep);
    let saverepeMsg = await saverep.json();
    //alert("response JSON ::: of update number ::::: " + JSON.stringify(saverepeMsg));

    if (saverepeMsg.status && saverepeMsg.status == "success") {
      if (fieldName === "added_dids") {
        setSelectedPHnums((prev) => [...prev, ...updatePHNum]);
        setdbPhoneNumbers((prev) => [...prev, ...updatePHNum]);
        setSuccessMessage(`Telephone Number ${updatePHNum} added successfully.`); // success pop up message.
        //setHgUpdated(true);
      } else {
        const updateAddPHNum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums(updateAddPHNum);
        setdbPhoneNumbers(updateAddPHNum);
        setSuccessMessage(
          `Telephone Number ${updatePHNum} removed successfully.`
        ); // success pop up message.
        //setHgUpdated(true);
      }
      setfreePhoneFlag(true);
    } else {
      if (fieldName === "removed_dids") {
        const modifynum = selectedPHnums.filter(
          (num) => !updatePHNum.includes(num)
        );
        setSelectedPHnums([...modifynum, ...updatePHNum]);
        setdbPhoneNumbers([...modifynum, ...updatePHNum]);
      }
    }
    setIsloading(false);
  }

  const handleVoiceChange = (e) => {
    const selectedId = parseInt(e.target.value);
    setValue("general.voice_type", selectedId, { shouldDirty: true });
    const selectedVoiceObj = voices.find(
      (voice) => voice.voiceid === selectedId
    );

    if (selectedVoiceObj) {
      setSelectedVoice(selectedVoiceObj.voiceurl);
    }
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.load(); // Load new audio
      // audioRef.current.play(); // Auto-play new audio
    }
  }, [selectedVoice]);

  const nameValue = watch("general.name");

  return (
    <>
      <div className="general-settings">{t("general")}</div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("Name")}</div>
        <div className="d-flex w-30">
          <div className="phoneselect w-100" title={nameValue || ''}>
            <input
              maxLength={50}
              className="form-control"
              {...register("general.name", { required: "Name is required" })}
            />
            {errors?.general?.name && (
              <p className="text-danger">{errors?.general?.name?.message}</p>
            )}
          </div>
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("extension")}</div>
        <div className="w-30">
          <input
            type="text"
            className="w-100"
            disabled={assocCallFlows?.length > 0}
            title={assocCallFlows?.length > 0 ? `Cannot edit extension as call flows are associated : ${assocCallFlows?.map((ele) => ele.name)?.toString()}` : ""}
            maxLength={5}
            {...register("general.extension", {
              setValueAs: (value) => Number(value),
              required: "Extension is required",
              minLength: {
                value: 3,
                message: "Extension must be at least 3 characters",
              },
              maxLength: {
                value: 5,
                message: "Extension must not exceed 5 characters",
              },
            })}
            onKeyPress={(event) => {
              if (!/[0-9]/.test(event.key)) {
                event.preventDefault();
              }
            }}
            onChange={(e) => {
              if (e.target.value !== "") {
                if (e.target.value.length >= 3 && e.target.value.length <= 5) {
                  if (parseInt(defaultExtension) === parseInt(e.target.value)) {
                    clearErrors("general.extension");
                  } else {
                    checkAvailability(e);
                  }
                } else {
                  clearErrors("general.extension");
                  setCheckAvailbility(false);
                  apiRequest = false;
                }
                setValue("general.extension", parseInt(e.target.value), {
                  shouldDirty: true,
                });
              } else {
                setValue("general.extension", "", {
                  shouldDirty: true,
                });
                clearErrors("general.extension");
                setCheckAvailbility(false);
                apiRequest = false;
              }
            }}
          />
          {errors?.general?.extension && (
            <>
              {checkAvailbility ? (
                <p style={{ color: "Green" }} className="clr-red">
                  {errors?.general?.extension?.message}
                </p>
              ) : (
                <p className="text-danger">
                  {errors?.general?.extension?.message}
                </p>
              )}
            </>
          )}
        </div>
      </div>

      <div className="add-numbermain align-items-start">
        <div className="tel-numbers">
          Voice <br />
          <span class="phrecording text-secondary">
            This is the voice a caller will hear when they call this Luna
            profile
          </span>
        </div>
        <div className="d-flex w-30 flex-column">
          <div className="phoneselect w-100">
            <select
              value={watch("general.voice_type")}
              className="form-select ms-3"
              onChange={(e) => handleVoiceChange(e)}
            >
              {voices.map((voice) => (
                <option value={voice.voiceid}>{voice.title}</option>
              ))}
            </select>
          </div>
          <audio ref={audioRef} controls>
            <source src={selectedVoice} type="audio/mp3" />
          </audio>
        </div>
      </div>

      <TelephoneNumbers
        savedPhoneNumbers={selectedPHnums}
        setSavedPhoneNumbers={setSelectedPHnums}
        setSuccessMessage={setSuccessMessage}
        uniqueid={lunaid}
        setUpdatePHNum={setUpdatePHNum}
        setUpdateNumbersExecuted={setUpdateNumbersExecuted}
        sourceNumber={sourceNumber}
        setDeleteNumberFlag={setDeleteNumberFlag}
        dbPhoneNumbers={dbPhoneNumbers}
      />
      <div className="add-numbermain">
        <div className="tel-numbers">{t("location")}</div>
        <div className="phoneselect w-30">
          <MDBSelect
            className="w-100"
            name="San Jose"
            search
            data={allLocations}
            value={parseInt(watch("general.loc_id"))}
            onChange={(e) => {
              if (e && e.value) {
                setValue("general.loc_id", parseInt(e.value), {
                  shouldDirty: true,
                });
              }
            }}
          />
        </div>
      </div>
      <div className="add-numbermain">
        <div className="tel-numbers">{t("billing_Group")}</div>
        <div className="phoneselect w-30">
          <MDBSelect
            className="w-100"
            name="San Jose"
            data={billingGroupList}
            value={parseInt(watch("general.bill_grp_id"))}
            search
            onChange={(e) => {
              if (e && e.value) {
                setValue("general.bill_grp_id", parseInt(e.value), {
                  shouldDirty: true,
                });
              }
            }}
          />
        </div>
      </div>
    </>
  );
}

export default LunaGeneralSettings;
